<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<ng-container>
		<div class="flex flex-col">
			<h3 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('massPrint.filterDialogTitle') }}</h3>
			<mat-dialog-content class="overflow-hidden">
				<div class="grid grid-rows-3" style="{{ !layoutService.isMobile() ? 'width: 500px' : '' }}">
					<mat-form-field appearance="fill">
						<mat-label>{{ t('massPrint.dates') }}</mat-label>
						<mat-select [formControl]="filterDate" name="filter-date-cy" required>
							@for (dateOption of dateOptions; track dateOption) {
								<mat-option [value]="dateOption">{{ dateOption | date: 'MMMM yy' : '' : locale }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</mat-dialog-content>
		</div>
	</ng-container>
	<ng-container>
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" [disabled]="filterDate.invalid" color="primary" mat-raised-button type="submit">
				<mat-icon>check</mat-icon>
				@if (!isMobile) {
					<span>
						{{ t('common.apply') }}
					</span>
				}
			</button>
		</mat-dialog-actions>
	</ng-container>
</div>
